const TIRE_QUALITY_OPTIONS = ["New", "Used"];

const trimValue = (value) => String(value || "").trim();

export const formatTireSizeInput = (raw = "") => {
  const digits = (raw || "").replace(/\D/g, "").slice(0, 7);
  const parts = [];
  if (digits.length > 0) parts.push(digits.slice(0, 3));
  if (digits.length > 3) parts.push(digits.slice(3, 5));
  if (digits.length > 5) parts.push(digits.slice(5, 7));
  return parts.join("/");
};

export const createTireInitialValues = (userId = "") => ({
  brand: "",
  size: "",
  quantity: "",
  buyPrice: "",
  price: "",
  quality: "",
  invoiceNo: "",
  po: "",
  vendor: "",
  location: "",
  user_id: userId,
});

export const prepareTireFormValues = (value = {}, userId = "") => ({
  ...createTireInitialValues(userId),
  ...value,
  brand: value.brand || "",
  size: formatTireSizeInput(value.size || ""),
  quantity: value.quantity ?? "",
  buyPrice: value.buyPrice ?? "",
  price: value.price ?? "",
  quality: value.quality || "",
  invoiceNo: value.invoiceNo || "",
  po: value.po || "",
  vendor: value.vendor || "",
  location: value.location?._id || value.location || "",
  user_id: value.user_id || userId,
});

export const buildTirePayload = (value = {}, userId = "") => {
  const prepared = prepareTireFormValues(value, userId);

  return {
    ...prepared,
    brand: trimValue(prepared.brand),
    size: formatTireSizeInput(prepared.size),
    quantity:
      prepared.quantity === "" || prepared.quantity === null || typeof prepared.quantity === "undefined"
        ? ""
        : String(prepared.quantity).trim(),
    buyPrice:
      prepared.buyPrice === "" || prepared.buyPrice === null || typeof prepared.buyPrice === "undefined"
        ? ""
        : String(prepared.buyPrice).trim(),
    price:
      prepared.price === "" || prepared.price === null || typeof prepared.price === "undefined"
        ? ""
        : String(prepared.price).trim(),
    quality: prepared.quality || "",
    invoiceNo: trimValue(prepared.invoiceNo),
    po: trimValue(prepared.po),
    vendor: trimValue(prepared.vendor),
    location: prepared.location || null,
    user_id: prepared.user_id || userId,
  };
};

// Receipt tire creation uses the default fields without storage locations.
export const getTireFormFields = (vendorOptions = [], locationOptions) => [
  { name: "brand", label: "Brand", type: "text" },
  {
    name: "size",
    label: "Size",
    type: "text",
    placeholder: "245/55/18",
    helperText: "Format: ###/##/##",
    formatter: formatTireSizeInput,
    inputProps: { maxLength: 10 },
  },
  { name: "quantity", label: "Quantity", type: "number" },
  { name: "buyPrice", label: "Buy Price ($)", type: "number" },
  { name: "price", label: "Sell Price ($)", type: "number" },
  {
    name: "quality",
    label: "Tire Type",
    type: "select",
    options: TIRE_QUALITY_OPTIONS.map((option) => ({
      value: option,
      label: option,
    })),
  },
  { name: "invoiceNo", label: "Invoice No.", type: "text" },
  { name: "po", label: "PO", type: "text" },
  { name: "vendor", label: "Vendor", type: "select", options: vendorOptions },
  ...(locationOptions ? [
    { name: "location", label: "Location", type: "select", options: locationOptions },
  ] : []),
];
